import React from "react";
import LabelValuePair from "../common/LabelValuePair";
import { AuditLog, AuditLogTypeLabels } from "../../models/AuditLog";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogNarrow } from "@/lib/dialogSize";

/** Field labels for the export filter the entry records, in the order the Source Links page shows them. */
const FILTER_LABELS: [key: string, label: string][] = [
  ["ExportName", "Export"],
  ["EntityType", "Entity type"],
  ["Outcome", "Outcome"],
  ["Reason", "Failure reason"],
  ["FailureReason", "Failure reason"],
  ["State", "State"],
  ["Owner", "Owner"],
  ["Regressed", "Regressed only"],
  ["FailedBefore", "Failed before"],
  ["Search", "Search"],
];

/**
 * A Source Links export being started, or a finished one downloaded. The entry holds the filter the export ran under
 * and the reason given, never the rows it produced.
 */
export const ViewSourceLinksExportAuditLogDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
}> = ({ auditLog, open, onClose }) => {
  const data = (() => {
    if (!auditLog?.additionalData) return null;
    try {
      return JSON.parse(auditLog.additionalData) as Record<string, unknown>;
    } catch {
      return null;
    }
  })();

  const shown = (value: unknown) =>
    value !== null && value !== undefined && value !== "" && value !== false;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className={`${dialogNarrow} overflow-hidden`}>
        {auditLog ? (
          <>
            <DialogHeader>
              <DialogTitle>{AuditLogTypeLabels[auditLog.eventType]}</DialogTitle>
            </DialogHeader>

            <Separator />

            <div className="flex flex-col gap-2 py-2">
              {data && shown(data.RequestReason) && (
                <LabelValuePair label="Reason" value={String(data.RequestReason)} />
              )}
              {data &&
                FILTER_LABELS.filter(([key]) => shown(data[key])).map(([key, label]) => (
                  <LabelValuePair key={key} label={label} value={String(data[key])} />
                ))}
              {data && FILTER_LABELS.every(([key]) => !shown(data[key])) && (
                <LabelValuePair label="Filter" value="All source links" />
              )}
              <LabelValuePair label="Performed by" value={auditLog.performerEmailAddress} />
              <LabelValuePair label="Event date" value={auditLog.eventDate} />
            </div>
          </>
        ) : (
          <div />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewSourceLinksExportAuditLogDetailsModal;
